import React from 'react';
// verificar colocar for=ID nos label
import { useState } from 'react';


export function ConfirmPasswordInput(props) {

    const [toggleState, setToggleState] = useState(false);

    const handleToggle = () => {
      setToggleState(x=>!x);
    }

    return(
      <section className="passwordSection">

        <div className="form-group form-icon">
          <label className="form-label">Crie uma senha *</label>
          <input type={!!toggleState ? "text" : "password"}
            className={"form-input form-icon-lock"/*`input ${fail ? "input--fail" : null} `*/}
            placeholder={"Insira a senha"}
            name={props.name}
            value={props.value}
            onChange={props.handleChange}
            autoComplete="off"
            minLength="8"
            required={true}
          />
          {props.value.length<8
              ?(<p className="dica">{"Senha curta, sua senha deve conter no mínimo 8 caracteres (até 32)"}</p>)
              :<></>
          }
        </div>

        <div className="form-group form-icon">
          <label className="form-label">Repita a senha criada *</label>
          <input type={!!toggleState ? "text" : "password"}
            id="senhaUsuarioRepetida"
            className={"form-input form-icon-lock"}
            placeholder={"Insira novamente a senha"}
            name={props.nameConfirm}
            value={props.valueConfirm}
            onChange={props.handleChange}
            autoComplete="off"
            title="Somente letras e numeros, Começando por uma letra. Não pode ter espaço e nem caracteres especiais"
            minLength="8"
            required={true}
          />
          {props.valueConfirm.length>0 && props.value!==props.valueConfirm
              ?(<p className="aviso">Senhas Diferentes</p>)
              :<></>
          }
        </div>

        <div className="showPasswordButton" onClick={handleToggle}>
              {/*!!toggleState
                 ? <img alt="olho" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABDUlEQVQ4jd2SvW3DMBBGbwQVKlyo4BGC4FKFS4+TATKCNxAggkeoSpHSRQbwAB7AA7hQoUKFLH6E2qQQHfgHdpo0yQHX8T3exyPR/ytlQ8kOhgV7FvSx9+xglA3lM3DBgh0LPn/onbJhcQ0bv2SHlgVgQa/suFHVkCg7bm5gzB2OyvjlDFdDcoa19etZMN8Qp7oUDPEM2KFV1ZAQO2zPMBERO7Ra4JQNpRa4K4FDS0R0IdneCbQLb4/zh/c7QdH4NL40tPXrovFpjHQr6PJ6yr5hQV80PiUiIm1OKxZ0LICS8TWvpyyOf2DBQQtcXk8Zi3+JcKfNafVsjZ0WfGgJlZZQxZjdwzX+ykf6u/UF0Fwo5Apfcq8AAAAASUVORK5CYII="
                   />
                 : <img alt="olho" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABDUlEQVQ4jd2SvW3DMBBGbwQVKlyo4BGC4FKFS4+TATKCNxAggkeoSpHSRQbwAB7AA7hQoUKFLH6E2qQQHfgHdpo0yQHX8T3exyPR/ytlQ8kOhgV7FvSx9+xglA3lM3DBgh0LPn/onbJhcQ0bv2SHlgVgQa/suFHVkCg7bm5gzB2OyvjlDFdDcoa19etZMN8Qp7oUDPEM2KFV1ZAQO2zPMBERO7Ra4JQNpRa4K4FDS0R0IdneCbQLb4/zh/c7QdH4NL40tPXrovFpjHQr6PJ6yr5hQV80PiUiIm1OKxZ0LICS8TWvpyyOf2DBQQtcXk8Zi3+JcKfNafVsjZ0WfGgJlZZQxZjdwzX+ykf6u/UF0Fwo5Apfcq8AAAAASUVORK5CYII="
                   />
              */}
        </div>

      </section>
    );
}

export default ConfirmPasswordInput;
